import React, { useEffect, useMemo, useState } from "react";

const AGE_OPTIONS = Array.from({ length: 18 }, (_, i) => i);

/**
 * Structured UI for customer chat when API returns children_age_picker.
 * Sends ages as a space-separated line (parsed by backend NLU).
 */
export default function ChildrenAgePicker({
  childrenCount,
  preselectedAges = [],
  disabled,
  onConfirm,
}) {
  const n = Math.min(17, Math.max(0, Number(childrenCount) || 0));
  const initial = useMemo(() => {
    const row = [];
    for (let j = 0; j < n; j += 1) {
      const v = preselectedAges[j];
      row.push(v != null && v !== "" ? String(Number(v)) : "");
    }
    return row;
  }, [n, preselectedAges]);

  const [ages, setAges] = useState(initial);

  useEffect(() => {
    setAges(initial);
  }, [initial]);

  if (n < 1) return null;

  const allChosen = ages.every((a) => a !== "" && !Number.isNaN(Number(a)));

  const setOne = (idx, val) => {
    setAges((prev) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const handleSubmit = () => {
    if (!allChosen || disabled) return;
    const nums = ages.map((a) => Number(a));
    onConfirm?.(nums);
  };

  return (
    <div className="hr-cvac-agepicker" dir="rtl">
      <p className="hr-cvac-agepicker__hint">בחרו גיל לכל ילד/ה (0–17):</p>
      <div className="hr-cvac-agepicker__row">
        {ages.map((val, idx) => (
          <label key={idx} className="hr-cvac-agepicker__field">
            <span className="hr-cvac-agepicker__lbl">{`ילד ${idx + 1}`}</span>
            <select
              className="hr-cvac-agepicker__select"
              value={val}
              onChange={(e) => setOne(idx, e.target.value)}
              disabled={disabled}
              aria-label={`גיל ילד ${idx + 1}`}
            >
              <option value="">—</option>
              {AGE_OPTIONS.map((a) => (
                <option key={a} value={String(a)}>
                  {a}
                </option>
              ))}
            </select>
          </label>
        ))}
      </div>
      <button
        type="button"
        className="hr-cvac-agepicker__btn"
        disabled={disabled || !allChosen}
        onClick={handleSubmit}
      >
        אישור גילאים
      </button>
    </div>
  );
}
